export enum PensionType {
    IndividualPersonalPension = "Individual Personal Pension",
    IndividualStakeholderPersonalPension = "Individual Stakeholder Personal Pension",
    SelfInvestedPersonalPension = "Self Invested Personal Pension",
    Section226RetirementAnnuity = "Section 226 Retirement Annuity",
    FreeStandingAVC = "Free Standing AVC",
    AppropriatePersonalPensionScheme = "Appropriate Personal Pension Scheme",
    GroupPersonalPension = "Group Personal Pension",
    GroupStakeholderPersonalPension = "Group Stakeholder Personal Pension",
    IndividualPersonalPensionNotSure = "Personal Pension but not sure which scheme",
}

export enum Provider {
    AbbeyLifeAssuranceCompanyLimited = "Abbey Life Assurance Company Limited",
    ABCInsurance = "ABC Insurance",
    AberdeenAssetManagementLimited = "Aberdeen Asset Management Limited",
    AceEuropeanGroupLimited = "Ace European Group Limited",
    AdmiralInsuranceServices = "Admiral Insurance Services",
    Aegon = "Aegon",
    AgeasInsuranceLimited = "Ageas Insurance Limited",
    AJBellPlatinumSIPP = "AJ Bell Platinum SIPP",
    AJBellYouinvest = "AJ Bell Youinvest",
    AllianceTrust = "Alliance Trust",
    AnsvarInsuranceCompanyLimited = "Ansvar Insurance Company Limited",
    AonHewitt = "Aon Hewitt",
    AriaAssistance = "Aria Assistance",
    AspenInsuranceUkLimited = "Aspen Insurance Uk Limited",
    AssicurazioniGeneraliSpa = "Assicurazioni Generali Spa",
    AssociatedBritishFoodsPensionScheme = "Associated British Foods Pension Scheme",
    AssurantSolutions = "Assurant Solutions",
    AtradiusCreditInsurance = "Atradius Credit Insurance",
    AvalonInvestmentServices = "Avalon Investment Services",
    AvivaInsurance = "Aviva Insurance",
    AXAWealthManagement = "AXA Wealth Management",
    BAndCEManagementLimited = "B and CE Management limited",
    BAESystems = "BAE Systems",
    BaillieGiffordLifeLimited = "Baillie Gifford Life Limited",
    BankOfAmericaMerrillLynchUKPensionPlan = "Bank of America Merrill Lynch UK Pension Plan",
    BaptistInsuranceCompanyPlc = "Baptist Insurance Company plc",
    BarclaysStaffPensionsSchemeBarclaysTeam = "Barclays Staff Pensions Scheme Barclays Team",
    BarnettWadingham = "Barnett Wadingham",
    BBCPensionAndBenefitCentre = "BBC Pension & Benefit Centre",
    BisonGroupPensionFund = "Bison group pension fund",
    BlackRock = "BlackRock",
    BlueSkyPensions = "BlueSky Pensions",
    BrightGrey = "Bright grey",
    BritInsuranceLimited = "Brit insurance limited",
    BritishAirwaysPensions = "British Airways Pensions",
    BritishAviationInsuranceCompanyLimited = "British aviation insurance company limited",
    BrookeNorthPensionScheme = "Brooke North Pension Scheme",
    BUPAPensions = "BUPA Pensions",
    CanadaLife = "Canada Life",
    CapitaSBJBenefitConsultants = "Capita - SBJ Benefit Consultants",
    CapitaEmployeeBenefits = "Capita Employee Benefits",
    CardiffPinnacle = "Cardiff pinnacle",
    CaterpillarDCPensionTrustLimited = "Caterpillar DC Pension Trust Llimited",
    CatlinInsuranceCompanyUKLimited = "Catlin insurance company uk limited",
    ChildrensMutual = "Childrens mutual",
    ChinaInsuranceCompanyUKLimited = "China Insurance Company UK Limited",
    ChubbCustomInsuranceCompany = "Chubb custom insurance company",
    ChurchillInsuranceCompanyLimited = "Churchill insurance company limited",
    CignaLifeInsuranceCompany = "Cigna life insurance company",
    ClericalMedicalInvestmentGroupLimited = "Clerical Medical Investment Group Limited",
    CnaInsuranceCompanyLimited = "Cna insurance company limited",
    CoOperativeGroup = "Co-Operative Group",
    CoatsPensionPlan = "Coats Pension Plan",
    CofundsLimited = "Cofunds Limited",
    CollingwoodInsuranceCompanyLimited = "Collingwood Insurance Company Limited",
    CombinedInsuranceCompanyOfAmerica = "Combined Insurance Company of America",
    CongregationalAndGeneralInsurancePlc = "Congregational and general insurance plc",
    CornishMutualAssuranceCompanyLimited = "Cornish mutual assurance company limited",
    CountrywideSaveAndProsper = "Countrywide - Save and Prosper",
    CountrywideAssured = "Countrywide Assured",
    CurtisBanksPLC = "Curtis Banks PLC",
    CXReinsuranceCompanyLimited = "CX Reinsurance Company Limited",
    DasLegalExpensesInsuranceCompanyLimited = "Das legal expenses insurance company limited",
    DepartmentOfEducation = "Department of Education",
    DHLPensionsDepartment = "DHL Pensions Department",
    DomesticAndGeneralInsurancePlc = "Domestic and general insurance plc",
    DsgiPensionBuilder = "Dsgi Pension Builder",
    EatonPensionPlan = "Eaton Pension Plan",
    EDFEnergyPensionScheme = "EDF Energy Pension Scheme",
    ElectricalContractors = "Electrical contractors insurance company ltd",
  EnduranceWorldwide = "Endurance worldwide insurance limited",
  EngageMutual = "Engage Mutual",
  EnterpriseInsurance = "Enterprise Insurance Company plc",
  EquineAndLivestock = "Equine and Livestock Insurance Company Ltd",
  Equiniti = "Equiniti limited",
  EquitableLife = "Equitable Life",
  Esure = "Esure insurance limited",
  EulerHermes = "Euler Hermes UK plc",
  EuropeanRisk = "European Risk Insurance Company",
  ExeterFriendly = "Exeter Friendly Society Limited",
  FaradayReinsurance = "Faraday reinsurance company limited",
  FederalInsurance = "Federal Insurance Company",
  Fidelity = "Fidelity",
  FidelitySIPP = "Fidelity SIPP team",
  FinancialInsurance = "Financial Insurance Company Limited",
  ForeignAndColonial = "Foreign and Colonial",
  ForestersFriendly = "Foresters friendly society",
  ForestersLife = "Foresters Life",
  FriendsLifeWinterthur = "Friends Life - ex. Winterthur",
  FriendsLifeAXA = "Friends Life - ex AXA",
  FriendsLifeProvident = "Friends Life - ex Friends Provident",
  GenworthFinancial = "Genworth financial",
  GreshamInsurance = "Gresham insurance company limited",
  GuardianFinancial = "Guardian Financial Services",
  GuinnessMahonTrust = "Guinness Mahon Trust Corporation Ltd",
  HainCelestialUK = "Hain celestial uk pension plan",
  HalifaxFinancial = "Halifax Financial Services",
  HalifaxShareDealingSIPP = "Halifax Share Dealing SIPP",
  HargreavesLansdown = "Hargreaves Lansdown Asset Management Limited",
  HartleySAS = "Hartley SAS Ltd",
  HastingsDirect = "Hastings Direct",
  HazellCarr = "Hazell Carr",
  HDIGerlingIndustrial = "HDI Gerling Industrial Insurance Company",
  HendersonGlobalInvestors = "Henderson global investors",
  HitachiCapital = "Hitachi Capital Insurance Europe Limited",
  HoneywellPension = "Honeywell Pension Scheme",
  Hornbuckle = "Hornbuckle",
  HSAdministration = "HS Administration Services",
  HSBCLife = "HSBC Life",
  InternationalInsuranceHanover = "International Insurance Company of Hanover IT",
  InvestmentSolutions = "Investment Solutions Limited",
  ITTIndustriesPension = "ITT Industries General Pension Plan",
  JamesHayPartnership = "James Hay Partnership",
  JardineLloydThompson = "Jardine Lloyd Thompson",
  JessopFundManagers = "Jessop Fund Managers",
  JPMorganUKPension = "JP Morgan UK Pension Plan",
  JustRetirement = "Just retirement limited",
  KillikCoSIPP = "Killik & Co SIPP",
  LampInsurance = "Lamp Insurance Company Limited",
  LawUnionRock = "Law Union Rock Insurance Company Ltd",
  LCPDCLink = "LCP DC Link Ltd",
  LegalAndGeneral = "Legal and General",
  LegalAndGeneralNationwide = "Legal and General - Nationwide",
  LendLeasePension = "Lend Lease Pension Scheme",
  LibertyInternationalUnderwriters = "Liberty international underwriters",
  LibertyMutualEurope = "Liberty mutual insurance europe limited",
  LibertySIPP = "Liberty SIPP",
  LifeTrust = "Life Trust plc",
  LionInsurance = "Lion Insurance Company Limited",
  LiverpoolMarineGeneral = "Liverpool marine and general insurance co ltd",
  LondonEdinburgh = "London and Edinburgh Insurance Company Limited",
  LondonGeneral = "London General Insurance Company Limited",
  LondonGuaranteeReinsurance = "London Guarantee and Reinsurance Company Limited",
  LV = "LV",
  LVRetirement = "LV= Retirement",
  Makro = "Makro",
  MarineAndGeneralMutualLifeAssuranceSociety = "Marine and General Mutual Life Assurance Society",
  MarkelInternationalInsuranceCompany = "Markel International Insurance Company",
  MarketguardInsuranceCompanyLimited = "Marketguard insurance company limited",
  MarksAndSpencerMoney = "Marks and Spencer Money",
  MercerHR = "Mercer HR",
  MercerHumanResourceConsulting = "Mercer Human Resource Consulting",
  MerchantsInvestors = "Merchants Investors",
  MetlifeInsuranceLimited = "Metlife Insurance Limited (Living Time)",
  MinsterInsuranceCompanyLimited = "Minster Insurance Company Limited",
  MitsuiSumitomoInsuranceCompanyEuropeLtd = "Mitsui Sumitomo Insurance Company Europe Ltd",
  MMAInsurancePlc = "MMA Insurance plc",
  MomentumPensions = "Momentum Pensions",
  MonarchAssurancePlc = "Monarch assurance plc",
  MondialAssistance = "Mondial Assistance",
  MorleyPooledPensionsLimited = "Morley pooled pensions limited",
  MotorsInsuranceCompanyLimited = "Motors Insurance Company Limited",
  MSLLegal = "MSL Legal",
  MunichReinsuranceCompany = "Munich reinsurance company",
  MunicipalMutualInsuranceLimited = "Municipal mutual insurance limited",
  MyCSP = "My CSP",
  NationalEmployersLifeAssCoLtd = "National Employers Life Ass Co Ltd",
  NationalHousebuildingCouncil = "National Housebuilding Council",
  NationalPensionTrust = "National Pension Trust",
  NationalPharmacyAssociation = "National Pharmacy Association",
  NationalVulcanEngineeringInsuranceGroup = "National Vulcan Engineering Insurance Group",
  Nationwide = "Nationwide",
  NatwestLife = "Natwest Life",
  NavigatorsAndGeneralInsuranceCompanyLtd = "Navigators and General Insurance Company Ltd",
  NewIndiaAssuranceCompanyLimited = "New india assurance company limited",
  NewlineodyesseyAmericaReinsuranceCorp = "Newlineodyessey america reinsurance corp",
  NFUMutual = "NFU Mutual",
  Nucleus = "Nucleus",
  OcasoSaUkBranch = "Ocaso sa uk branch",
  OdysseyRe = "Odyssey re",
  OldMutualLifeAssuranceCoLtd = "Old Mutual Life Assurance Co Ltd",
  OldMutualWealth = "Old Mutual Wealth",
  OxfordLifeAssuranceCompanyLtd = "Oxford Life Assurance Company Ltd",
  PegasusAssuranceLimited = "Pegasus Assurance limited",
  Pensionology = "Pensionology",
  PensionsManagementLimited = "Pensions Management Limited",
  PensionsManagementSWFLimited = "Pensions management swf limited",
  PersonalAssurancePlc = "Personal assurance plc",
  PHOExPearlLifeNPISwissAlbaCorp = "PHO--ex PearlLife NPI/Swiss/Alba Corp",
  PHOExScotProvScotMutExBAACIALBAIndividual = "PHO-ex ScotProv/ScotMut/ex BAACIALBA individual",
  PhoenixLifeAssurance = "Phoenix Life Assurance (ex Century Life/NEL)",
  PlatformClientServicesAegonClientServices = "Platform Client Services - Aegon Client Services",
  PointonYork = "Pointon York",
  PoliceMutual = "Police Mutual",
  PostOfficeInsuranceSociety = "Post Office Insurance society",
  Prudential = "Prudential",
  RailwaysPensionScheme = "Railways Pension Scheme",
  ReAssure = "Re-Assure",
  ReAssureBarclaysLifeAssuranceLimited = "Re-Assure Barclays Life Assurance Limited",
  RelianceMutual = "Reliance Mutual",
  RetirementAdvantage = "Retirement Advantage",
  RexelPensionScheme = "Rexel Pension Scheme",
  RGAReinsuranceUKLimited = "RGA Reinsurance UK Limited",
  RollsRoycePensionFund = "Rolls Royce Pension Fund",
  RowanmoorPlc = "Rowanmoor plc",
  RoyalAndSunAllianceAssuranceLimited = "Royal  and Sun Alliance Assurance Limited",
  RoyalLondonExCooperativeFinancialServices = "Royal London (ex Co-operative Financial Services)",
  RoyalLondonExScottishLife = "Royal London (ex Scottish Life)",
  RoyalLondonGlasgow = "Royal London - Glasgow",
  RoyalLondonGroup = "Royal London Group",
  RoyalLondonPooledPensionsCompanyLimited = "Royal london pooled pensions company limited",
  RoyalMailPension = "Royal Mail Pension",
  RoyalNationalPensionFundForNurses = "Royal national pension fund for nurses",
  SabreInsurance = "Sabre Insurance",
  SagaInsuranceCompanyLimited = "Saga insurance company limited",
  SalvationArmyGeneralInsuranceCorporation = "Salvation army general insurance corporation",
  SanlamInvestmentsAndPensions = "Sanlam Investments and Pensions",
  Santander = "Santander",
  SchlumbergerPensionScheme = "Schlumberger Pension Scheme",
  SCORGlobalLife = "SCOR Global Life",
  ScottishFriendlyAssuranceSocietyLimited = "Scottish Friendly Assurance Society limited",
  ScottishTemperanceAssuranceSocietyLimited = "Scottish Temperance Assurance Society limited",
  ScottishWidows = "Scottish Widows",
  SelestiaInvestmentsLimited = "Selestia investments limited",
  SiemensInvestorPlan = "Siemens Investor Plan",
  SippcentreAJBell = "Sippcentre (AJ Bell)",
  SippdealxtraAJBell = "Sippdealxtra (A J Bell)",
  SiriusInternationalInsuranceCorporation = "Sirius international insurance corporation",
  SkandiaLife = "Skandia Life",
  StJamesPlaceWealthManagement = "St James Place Wealth Management",
  StandardLifeAssuranceLimited = "Standard Life Assurance Limited",
  SuffolkLife = "Suffolk Life",
  SunLifeFinancialOfCanada = "Sun Life Financial of Canada",
  TeachersAssurance = "Teachers Assurance",
  TeachersPensions = "Teachers pensions",
  TheFundsNetworkPensionFidelity = "The Funds Network Pension (Fidelity)",
  TheInstituteOfPhysicsRetirementBenefitScheme = "The Institute of Physics Retirement Benefit Scheme",
  ThePensionsTrust = "The Pensions Trust",
  TheStPaulPensionPlan = "The St Paul Pension Plan",
  TowersWatson = "Towers Watson",
  Transact = "Transact",
  TruePotentialLLP = "True Potential LLP",
  UkCoalMineworkersPensionScheme = "Uk Coal Mineworkers Pension Scheme",
  UKLifeAssuranceCompanyLimited = "UK Life Assurance Company limited",
  VinciPensionsLimited = "Vinci Pensions Limited",
  Virgin = "Virgin",
  WHSmithPensionBuilder = "W H Smith pension builder",
  Wealthtime = "Wealthtime",
  WesleyanAssuranceSociety = "Wesleyan Assurance Society",
  WhitbreadGroupPensionFund = "Whitbread group pension fund",
  XafinityConsulting = "Xafinity consulting",
  XafinityPaymaster = "Xafinity paymaster",
  XafinitySIPPSASS = "Xafinity SIPP SASS",
  ZurichAssuranceEagleStar = "Zurich Assurance - Eagle Star",
  ZurichAssuranceLimited = "Zurich Assurance Limited",
  ZurichCorporatePensions = "Zurich Corporate Pensions",
  ZurichIntermediaryPlatform = "Zurich Intermediary Platform",
  ZurichSIPP = "Zurich SIPP"
}
